import React, { Suspense, lazy } from "react";
import { HelmetProvider } from "react-helmet-async";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";

const Home = lazy(() => import("./pages/Home"));
const Feedback = lazy(() => import("./pages/Feedback"));
const SuperBowl = lazy(() => import("./pages/SuperBowl"));
const VenueMap = lazy(() => import("./pages/VenueMap"));
const SwcVenueMap = lazy(() => import("./pages/SwcVenueMap"));
const ScoreWorldCup = lazy(() => import("./pages/ScoreWorldCup"));
const Recognition = lazy(() => import("./pages/Recognition"));
const IconLibrary = lazy(() => import("./pages/IconLibrary"));

const Loading: React.FC = () => (
  <div className="min-h-screen grid place-items-center text-slate-400">Loading…</div>
);

const App: React.FC = () => (
  <HelmetProvider>
    <Router>
      <Suspense fallback={<Loading />}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/feedback" element={<Feedback />} />
          <Route path="/super-bowl" element={<SuperBowl />} />
          <Route path="/venue-map" element={<VenueMap />} />
          <Route path="/swc-venue-map" element={<SwcVenueMap />} />
          <Route path="/score-world-cup" element={<ScoreWorldCup />} />
          <Route path="/recognition" element={<Recognition />} />
          <Route path="/icon-library" element={<IconLibrary />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Suspense>
    </Router>
  </HelmetProvider>
);

export default App;
